import { type FC } from 'react';
import { Provider } from 'react-redux';
import { type Store } from 'redux';
import { useLazyLoadQuery } from 'react-relay';
import { type Locale } from 'dibs-intl/exports/locales';
import { type DEVICE_TYPES } from 'dibs-buyer-layout/exports/deviceTypeEnums';

import { IntlProvider } from 'dibs-react-intl';
import { DibsWeb3ReactProvider } from 'dibs-crypto-utils/exports/DibsWeb3ReactProvider';

import { NftHeaderLayout } from '../nftHeader/NftHeaderLayout';
import { NftExhibitionLayout } from './NftExhibitionLayout';
import {
    NftExhibitionEntryQuery,
    type NftExhibitionEntryQueryType,
    type NftExhibitionEntryQuery$variables,
} from './NftExhibitionEntryQuery';

type Props = {
    locale: Locale;
    deviceType: DEVICE_TYPES;
    store: Store;
    variables: NftExhibitionEntryQuery$variables;
    isExhibitionLanding: boolean;
};

export const NftExhibitionWrapper: FC<Props> = ({
    locale,
    deviceType,
    store,
    variables,
    isExhibitionLanding,
}) => {
    const data = useLazyLoadQuery<NftExhibitionEntryQueryType>(NftExhibitionEntryQuery, variables);
    return (
        <IntlProvider locale={locale} disableTranslations>
            <DibsWeb3ReactProvider>
                <Provider store={store}>
                    <NftHeaderLayout
                        viewer={data.viewer}
                        isNftLandingPage
                        serverDeviceType={deviceType}
                    >
                        <NftExhibitionLayout
                            isExhibitionLanding={isExhibitionLanding}
                            viewer={data.viewer}
                        />
                    </NftHeaderLayout>
                </Provider>
            </DibsWeb3ReactProvider>
        </IntlProvider>
    );
};
